(() => {
    const titles = document.querySelectorAll('.accordion__title');

    titles.forEach(title => {
        title.addEventListener('click', () => {
            const contentId = title.getAttribute('aria-controls');
            const content = document.getElementById(contentId);
            const wrapper = title.closest('.accordion__div');
            const isExpanded = title.getAttribute('aria-expanded') === 'true';

            if (!content || !wrapper) return;

            title.setAttribute('aria-expanded', !isExpanded);
            content.style.display = isExpanded ? 'none' : 'block';
            wrapper.classList.toggle('is-active', !isExpanded);
        });
    });
})();